import React from 'react'
import PageBreakInput from './PageBreakInput'
import SectionInput from './SectionInput'
import VideoInput from './VideoInput'

class MetaInput extends React.Component {
  render() {
    switch (this.props.sub_type) {
      case 'page_break':
        return <PageBreakInput {...this.props} />
      case 'section':
        return <SectionInput {...this.props} />
      case 'video':
        return <VideoInput {...this.props} />
      default:
        throw Error('Field type is not recognized')
    }
  }
}
export default MetaInput
